module.exports = __webpack_public_path__ + "static/media/icon3.c3bd85e2.jpg";